import { Observable, of } from 'rxjs'

import { SearchAutoCompleteDocument, SearchAutoCompleteQuery } from '../../graphql/search'
import { right } from '../../utils/result'
import { mapRight } from '../../utils/rx/operators'
import { commaQueryFactory, SearchQueryResult } from './query'

export type SearchAutoCompleteProduct = SearchAutoCompleteQuery['autoComplete']['results'][number]

const autoCompleteQuery = commaQueryFactory(SearchAutoCompleteDocument)

export const searchAutoCompleteQuery = ({
  query,
}: {
  query?: string
}): Observable<SearchQueryResult<SearchAutoCompleteProduct[]>> =>
  !query
    ? of({ _tag: 'Right' as const, data: [] })
    : autoCompleteQuery({
        variables: { query },
      }).pipe(mapRight(({ data }) => right(data?.autoComplete?.results ?? [])))
